











































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { formatCurrency } from "@/shared/currency";
import { useContributionPlannerStore } from "@/employee/store/contributionPlanner";
import { useBirthYearStore } from "@/employee/store/birthYear";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class ContributionPlannerSummary extends Vue {
  contributionPlannerStore = useContributionPlannerStore();
  birthYearStore = useBirthYearStore();

  formatCurrency = formatCurrency;

  get hsaForecastRetirementAge (): number {
    const retirementYear = this.contributionPlannerStore.hsaForecast.
        hsaForecasts[this.contributionPlannerStore.hsaForecast.hsaForecasts.length - 1].year;
    return retirementYear - this.birthYearStore.birthYear;
  }

  get currentYearOopPercent (): string {
    return Math.round(this.contributionPlannerStore.hsaForecast.hsaForecasts[0].oopCoverageLikelihood) + "%";
  }

  get hsaBalancePrediction (): number {
    return this.contributionPlannerStore.hsaForecast.
        hsaForecasts[this.contributionPlannerStore.hsaForecast.hsaForecasts.length - 1].predictedHsaBalance;
  }

  get showNewUserSummary (): boolean {
    return !this.contributionPlannerStore.hsaForecastHasData && !this.contributionPlannerStore.hsaForecastLoading;
  }

  get showForecastSummary (): boolean {
    return this.contributionPlannerStore.hsaForecastHasData && !this.contributionPlannerStore.hsaForecastLoading;
  }

}
